// ##############################
// // // PATRIMOINE
// #############################

// ##############################
// // // Batiment
// #############################

const mbmtab = {
  mbminstalled: "Entité avec des équipements",
  criticity: "Criticité de l'entité",

}

const meter = {
  datedistribution: "Répartition des données de relève",
  functioncode: "Code fonction",
  creditline: "Ligne de crédit",
}
const usage = {
  name: "Nom",
  category: "Catégorie",
  associatedmeter: "Compteur associé",
  energy: "Fluide concerné",
  iotcount: "Nombre d'IoT associés",
  equipmentcount: "Nombre d'équipements associés",
  consumptionpart: "Part des consommations",
  consumptionpartmethod: "Méthode de calcul de la part des consommations",
  iot: "IoT associés",
  equipments: "Equipements associés",
}

const thresholdtext = {
  moderateairqualityco2threshold: "Seuil CO2 qualité d’air modérée",
  lowairqualityco2threshold: "Seuil CO2 qualité d’air basse",
  reducedtemperature: "Température réduite",
  comforttemperature: "Température de confort",
  lowhumiditylevel: "Limite environnement sec",
  highhumiditylevel: "Limite environnement humide",
}

const batiment = {
  parameters: {
    parameters: {
      picture: "Photo",
      key: "Clé /Code",
      address: "Adresse",
      siret: "Numéro SIRET",
      siren: "Numéro SIREN",
      nic: "Numéro NIC",
      floorcount: "Nombre de niveaux",
      roomcount: "Nombre de zones / salles",
      constructionyear: "Année de construction",
      constructionperiod: "Epoque de construction",
      commissioningyear: "Année de mise en service",
      structuretype: "Type de patrimoine",
      email: "Adresse email",
      phone: "Téléphone",
    },
    activity: {
      status: "Statut",
      nafcode: "Code NAF",
      activitytype: "Secteur d'activité",
      activitysubtype: "Sous-secteur d'activité",
      usagecode: "Code usage",
      usage: "Usage/Fonction entité",
      nontertiaryactivity: "Présence de co-activité non tertiaire",
    },
    dimension: {
      shape: "Forme de l'entité",
      length: "Longueur",
      width: "Largeur",
      height: "Hauteur moyenne",
      volume: "Volume",
      surface: "Surface",
      brutsurface: "Surface Utile Brute",
      heatedsurface: "Surface chauffée",
      cooledsurface: "Surface climatisée",
      floorsurface: "Surface Plancher",
      shonsurface: "Surface SHON",
      comments: "Commentaires",
      description: "Description",
    },
    occupation: {
      occupancycountperiode: "Nombre moyen d'occupants - Périodicité",
      occupancycountvalue: "Nombre moyen d'occupants - Valeur",
      maximalcapacity: "Capacité maximale",
      averageoccupancy: "Taux moyen d'occupation (%)",
      occupancytimeperiode: "Temps moyen occupation - Périodicité",
      occupancytimevalue: "Temps moyen occupation - Valeur",
      occupancycomments: "Fréquence d'occupation - Commentaires",
      mondayschedulestart: "Horaire standard d'ouverture le Lundi",
      tuesdayschedulestart: "Horaire standard d'ouverture le Mardi",
      wednesdayschedulestart: "Horaire standard d'ouverture le Mercredi",
      thursdayschedulestart: "Horaire standard d'ouverture le Jeudi",
      fridayschedulestart: "Horaire standard d'ouverture le Vendredi",
      saturdayschedulestart: "Horaire standard d'ouverture le Samedi",
      sundayschedulestart: "Horaire standard d'ouverture le Dimanche",
      mondayscheduleend: "Horaire standard de fermeture le Lundi",
      tuesdayscheduleend: "Horaire standard de fermeture le Mardi",
      wednesdayscheduleend: "Horaire standard de fermeture le Mercredi",
      thursdayscheduleend: "Horaire standard de fermeture le Jeudi",
      fridayscheduleend: "Horaire standard de fermeture le Vendredi",
      saturdayscheduleend: "Horaire standard de fermeture le Samedi",
      sundayscheduleend: "Horaire standard de fermeture le Dimanche",
      comments: "Commentaires",
      description: "Description",
    },
    properties: {
      lastaudit: "Date de dernier audit",
      performancegrade: "Performance - Note",
      performancecomment: "Performance - Commentaire",
      dilapidationgrade: "Vétusté - Note",
      dilapidationcomment: "Vétusté - Commentaire",
      architecturalconstraints: "Contraintes architecturales",
      architecturalconstraintscomment:
        "Contraintes architecturales - Commentaires",
      boilerroomcompliance: "Conformité chaufferie",
      boilerroomcompliancecomment: "Conformité chaufferie - Commentaires",
      otherproperties: "Autres propriétés",
      feedback: "REX occupants",
      lastrehabilitation: "Date de dernière réhabilitation",
      rehabilitationtype: "Type de réhabilitation",
      nextrehabilitation: "Date de prochaine réhabilitation",
      certification: "Certifications",
      internetaccess: "Accès internet",
      intertiarybill: "Entité assujettie au décret tertiairee",
    },
    other: {
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
      mbminstalled: "Equipements de pilotage sur site",
    },
  },
  contact: {
    contactlist: {
      name: "Nom ",
      key: "Clé / code",
      status: "Statut",
      role: "Poste / Fonction",
      company: "Structure / Société",
      phone: "Téléphone",
      email: "Email",
      comments: "Commentaires",
      external: "Tag - Interne / Externe / Autres",
      associatedfiles: "Fichiers associés",
      description: "Description",
    },
  },
  energy: {
    electricity: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    gas: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    water: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    heat: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    cold: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    fuel: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    wood: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    propane: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
  },
  structure: {
    synthesis: {
      uponderation: "Pondération (U structure)",
      ustructure: "Ustructure",
      airdeperdition: "Part Déperditions Renouvellement de l'air",
      thermicaldeperdition: "Part Déperditions ponts thermiques",
      jointwall: "Mitoyenneté",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    walls: {
      walls: {
        name: "Nom",
        key: "Clé/code",
        type: "Type de cloison",
        materials: "Matériaux",
        length: "Longueur",
        width: "Largeur",
        surface: "Surface",
        thickness: "Epaisseur",
        thicknessprecision: "Epaisseur - niveau de précision",
        walldependency: "Dépendance paroi",
        deperdition: "Déperdition vers",
        uponderation: "Pondération U paroi",
        thermicalresistance: "Résistance thermique paroi",
        uwall: "U paroi",
        deperditionpart: "Part des déperditions totales",
        wallorientation: "Orientation paroi",
        rooftilt: "Toiture - Inclinaison",
        performancegrade: "Performance Note",
        performancecomment: "Performance commentaires",
        dilapidationgrade: "Vétusté Note",
        dilapidationcomment: "Vétusté commentaires",
        otherproperties: "Autres propriétés",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      materials: {
        key: "Clé/code",
        name: "Matériau",
        refmaterial: "Matériau de référence",
        uncertainty: "Incertitude type matériau",
        umaterial: "U matériau",
        thickness: "Epaisseur",
        thicknessprecision: "Epaisseur - niveau de précision",
        comments: "Commentaires",
        category: "Catégorie",
        walltype: "Type de matériau",
        functionality: "Fonction",
        usualwall: "Type de paroi habituellement associé",
        thermicalconductivity: "Conductivité Thermique",
        thermicalresistance: "Résistance thermique",
        thermicalcapacity: "Capacité thermique",
        volumicmass: "Masse Volumique",
        carbonfootprint: "Empreinte carbone",
        greyenergy: "Energie grise",
        vapordiffusion: "Facteur de diffusion de la vapeur d'eau",
      },
    },
    tertiarybill: {
      walltype: "Typologie façade",
      wallisolation: "Isolation thermique des façades",
      pinionisolation: "Isolation thermique des pignons",
      mainthermicalisolation: "Mode d'isolation thermique principal",
      woodsthermicaltreatment: "Traitement thermique des menuiseries",
      rooftype: "Typologie toiture",
      roofthermicaltreatment: "Traitement thermique de la toiture",
      floortype: "Typologie plancher bas",
      floortisolation: "Isolation thermique du plancher bas",
    },
  },
  equipments: {
    synthesis: {
      other: "Autres propriétés libres",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    equipmentlist: {
      name: "Nom",
      key: "Clé/code",
      category: "Catégorie Système / usage",
      system: "Système",
      type: "Type d'équipement",
      status: "Statut",
      localization: "Localisation",
      energysource: "Source d'énergie",
      installationdate: "Année d'installation",
      divisionunit: "Clé de répartition",
      consumptionpart: "Part de la consommation",
      billingpart: "Part de la facturation",
      productionpart: "Part de la production",
      averageusageperiod: "Temps moyen utilisation - Périodicité",
      averageusagetime: "Temps moyen utilisation - Valeur",
      usagefrequency: "Fréquence d'utilisation - Commentaires",
      defaultsetpoint: "Consigne par défaut",
      weighting: "Pondération",
      efficiency: "Rendement",
      device: "Appareil",
      devicekey: "Clé",
      devicename: "Nom",
      devicecategory: "Catégorie",
      devicetechnology: "Techno",
      devicemodel: "Modèle",
      devicecaracteristicval:
        "Rendement d'impacts / Valeur caractéristique de performance",
      devicecaracteristicunit: "Unité",
      devicerenewalrateflow: "Taux de brassage (vol/h)",
      deviceelectricalpower: "Puissance élec.",
      devicethermicalpower: "Puissance thermique",
      deviceelectricalunitpower: "Puissance élec unitaire?",
      devicecoldpower: "Puissance frigorifique",
      devicecop: "COP",
      deviceefficiency: "Rendement",
      devicerateflow: "Débit",
      devicedimension: "Dimension",
      devicevalve: "Type de vanne",
      devicecarbonfootprint: "Empreinte carbone",
      devicegreyenergy: "Energie grise",
      performancegrade: "Commentaires propriétés",
      performancecomment: "Performance Note",
      dilapidationgrade: "Performance commentaires",
      dilapidationcomment: "Vétusté Note",
      otherproperties: "Autres propriétés",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    tertiarybill: {
      heating: "Chauffage",
      cooling: "Refroidissement",
      heatingproductiondevice: "Générateur principal chauffage",
      heatingdistributiondevice: "Type principal d'émetteur de chauffage",
      coolingproductiondevice: "Générateur principal de rafraîchissement",
      coolingdistributiondevice: "Type principal de ventilation",
      hotwaterdevice: "Type de production d'eau chaude sanitaire",
      officenaturallighting: "Niveau d'éclairage naturel des locaux",
      corridornaturallighting: "Niveau d'éclairage naturel des circulations",
      lightingdevice: "Type d'éclairage artificiel",
      elavatorcount: "Nombre d'ascenseurs",
      levelcount: "Nombre de niveau desservis",
      capacity: "Capacité individuelle",
      escalatorfulltime:
        "Nombre d'escalier mécanique en fonctionnement continu",
      escalatordetection: "Nombre d'escalier mécanique asservi à la détection",
      mecsidewalkfulltime:
        "Nombre de trottoir mécanique en fonctionnement continu",
      mecsidewalkdetection:
        "Nombre de trottoir mécanique asservi à la détection",
    },
  },
  renewables: {
    synthesis: {
      pv: "PV",
      pvrooforientation: "Orientation toiture",
      pvrooftilt: "Inclinaison",
      pvroofsurface: "Toiture - surface disponible",
      pvsolarmask: "Présence de masque solaire",
      pvheatingcompatibility: "Compatibilité avec le système de chauffage",
      pvfaisability: "Niveau de faisabilité",
      solarthermal: "Solaire thermique",
      solarthermalrooforientation: "Orientation toiture",
      solarthermalrooftilt: "Inclinaison",
      solarthermalroofsurface: "Toiture - surface disponible",
      solarthermalsolarmask: "Présence de masque solaire",
      solarthermalheatingcompatibility:
        "Compatibilité avec le système de chauffage",
      solarthermalsuitability: "Adéquation avec les besoins",
      solarthermalfaisability: "Niveau de faisabilité",
      biomass: "Biomasse",
      biomassgroundavailablesurface: "Surface terrain disponible",
      biomassdeliverycapacity: "Capacité de livraison",
      biomasssilocapacity: "Foncier suffisant pour silo",
      biomassheatingcompatibility: "Compatibilité avec le système de chauffage",
      biomassfaisability: "Niveau de faisabilité",
      geothermal: "Géothermie",
      geothermalgroundavailablesurface: "Surface terrain disponible",
      geothermalgroundtype: "Nature du sol",
      geothermalcompatibility: "Compatibilité avec le système de chauffage",
      geothermalfaisability: "Niveau de faisabilité",
      other: "Autres propriétés libres (ex : éolien, hydro ...)",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    equipmentlist: { name: "Nom", key: "Clé/code", type: "Type ENR" },
  },
  tertiarybill: {
    intertiarybill: "Entité assujettie au décret tertiaire",
    startdate: "Mois de début de la plage de 12 mois consécutif",
    djuref:
      "DJU de l'année de référence",
    electricityrefconsumption:
      "Electricité (kWh): consommation année de référence",
    gasrefconsumption:
      "Gaz naturel réseaux (kWh) : consommation année de référence",
    liquidgasrefconsumption:
      "Gaz naturel liquéfié (kg) : consommation année de référence",
    propanem3refconsumption:
      "Gaz propane (m3): consommation année de référence",
    propanekgrefconsumption:
      "Gaz propane (kg): consommation année de référence",
    butanem3refconsumption: "Gaz butane (m3): consommation année de référence",
    butanekgrefconsumption: "Gaz butane (kg): consommation année de référence",
    fuelrefconsumption:
      "Fioul domestique (l) : consommation année de référence",
    coalrefconsumption:
      "Charbon agglomérés et briquettes (kg) : consommation année de référence",
    houillerefconsumption: "Houille (kg) : consommation année de référence",
    industrywoodrefconsumption:
      "Bois Plaquettes d'industrie (kg) : consommation année de référence",
    forestwoodrefconsumption:
      "Bois Plaquettes forestières (kg) : consommation année de référence",
    granulewoodrefconsumption:
      "Bois Granulés (pellets) ou briquettes (kg) : consommation année de référence",
    logwoodrefconsumption:
      "Bois Bûches (Stère) : consommation année de référence",
    heatnetworkrefconsumption:
      "Réseau de chaleur (kWh) : consommation année de référence",
    coldnetworkrefconsumption:
      "Réseau de froid (kWh électrique) : consommation année de référence",
  },
};

// ##############################
// // // Compte
// #############################

const compte = {
  parameters: {
    key: "Clé/code",
    picture: "Photo",
    logo: "Logo",
    address: "Adresse principale",
    email: "Adresse email",
    phone: "Téléphone",
    associatedfiles: "Fichiers associés",
    comments: "Commentaires",
    description: "Description",
  },
  contact: {
    contactlist: {
      name: "Nom ",
      key: "Clé / code",
      status: "Statut",
      role: "Poste / Fonction",
      company: "Structure / Société",
      phone: "Téléphone",
      email: "Email",
      comments: "Commentaires",
      external: "Tag",
      associatedfiles: "Fichiers associés",
      description: "Description",
    },
  },

  tertiarybill: "Demande Interface avec OPERAT",
  energy: {
    electricity: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio:
          "Coefficient Energie Finale / Energie Primaire",
        co2ratio: "Emission de Co2 par kWh",
        energycosthph: "Coût de l'énergie HPH",
        energycosthpe: "Coût de l'énergie HPE",
        energycosthch: "Coût de l'énergie HCH",
        energycosthce: "Coût de l'énergie HCE",
        energycostpointe: "Coût de l'énergie Pointe",
        energycosthp: "Coût de l'énergie HP",
        energycosthc: "Coût de l'énergie HC",
        energycostbase: "Coût de l'énergie Base",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par kwh",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE)",
        status: "Statut",
        serialnumber: "Matricule",
        address: "Adresse",
        dso: "Distributeur associé",
        powersubscription: "PS",
        powersubscriptionhph: "Puissance Souscrite HPH",
        powersubscriptionhpe: "Puissance Souscrite HPE",
        powersubscriptionhch: "Puissance Souscrite HCH",
        powersubscriptionhce: "Puissance Souscrite HCE",
        powersubscriptionpointe: "Puissance Souscrite Pointe",
        powersubscriptionhp: "Puissance Souscrite HP",
        powersubscriptionhc: "Puissance Souscrite HC",
        powersubscriptionbase: "Puissance Souscrite Base",
        powersubscriptionmax: "Puissance Souscrite Max",
        acheminement: "Acheminement",
        segment: "Segment",
        monthlyconsumption: "Activation releve mensuelle",
        dailyconsumption: "Activation releve journalière",
        loadcurve: "Activation relève courbe de charge",
        contractualdata: "Activation relève données contractuelles",
        utilitydata: "Activation relève données de facturation",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation distributeur associée",
        utilityauthorization: "Autorisation fournisseur associée",
        reachedmaxpowerhce: "Pmax atteinte HCE",
        reachedmaxpowerhch: "Pmax atteinte HCH",
        reachedmaxpowerhph: "Pmax atteinte HPH",
        reachedmaxpowerhpe: "Pmax atteinte HPE",
        reachedmaxpowerpointe: "Pmax atteinte Pointe",
        reachedmaxpowerhc: "Pmax atteinte HC",
        reachedmaxpowerhp: "Pmax atteinte HP",
        reachedmaxpowerbase: "Pmax atteinte Base",
        maxpower: "Pmax",
        exceedingcost: "Coût des dépassement €",
        dataquality: "Notes - Qualité de la donnée",
        usagecode: "Code usage",
      },
    },
    gas: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energycost: "Coût de l'énergie",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par kwh",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        serialnumber: "Matricule",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        address: "Adresse",
        dso: "Distributeur associé",
        cja: "Capacité journalière d'acheminement (CJA)",
        acheminement: "Acheminement",
        profil: "Profil de consommation",
        car: "CAR (kWh/an)",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        utilitydata: "Activation relève données de facturation",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation distributeur associée",
        utilityauthorization: "Autorisation fournisseur associée",
        usagecode: "Code usage",
      },
    },

    water: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energycost: "Coût au m3",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par m3",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        serialnumber: "Matricule",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        address: "Adresse",
        dso: "Distributeur associé",
        diameter: "Diamètre",
        acheminement: "Acheminement",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation associée",
        utilityauthorization: "Autorisation fournisseur associée",
        utilitydata: "Activation relève données de facturation",
        usagecode: "Code usage",
      },
    },
    heat: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energyunit: "Unité de facturation (kWh/TV)",
        energycost: "Coût à l'unité",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par unité",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        serialnumber: "Matricule",
        address: "Adresse",
        dso: "Distributeur associé",
        acheminement: "Acheminement",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        utilitydata: "Activation relève données de facturation",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation associée",
        utilityauthorization: "Autorisation fournisseur associée",
        usagecode: "Code usage",
      },
    },
    cold: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energycost: "Coût au kwh",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par kwh",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        serialnumber: "Matricule",
        address: "Adresse",
        dso: "Distributeur associé",
        acheminement: "Acheminement",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation associée",
        usagecode: "Code usage",
        utilityauthorization: "Autorisation fournisseur associée",
        utilitydata: "Activation relève données de facturation",
      },
    },
    fuel: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energycost: "Coût au litre",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par litre",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        serialnumber: "Matricule",
        address: "Adresse",
        dso: "Distributeur associé",
        acheminement: "Acheminement",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation associée",
        usagecode: "Code usage",
        utilityauthorization: "Autorisation fournisseur associée",
        utilitydata: "Activation relève données de facturation",
      },
    },
    wood: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energycost: "Coût à l'unité",
        energyunit: "Unité de facturation (m3/kg)",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par unité",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        serialnumber: "Matricule",
        address: "Adresse",
        dso: "Distributeur associé",
        acheminement: "Acheminement",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation associée",
        usagecode: "Code usage",
        utilityauthorization: "Autorisation fournisseur associée",
        utilitydata: "Activation relève données de facturation",
      },
    },
    propane: {
      dso: {
        key: "Clé/code",
        name: "Nom Distributeur",
      },
      utilities: {
        key: "Clé/code",
        contractname: "Nom du contrat",
        contractnumber: "Numéro du contrat d'abonnement",
        tarifftype: "Type de tarif",
        name: "Nom Fournisseur",
        contractbegindate: "Date de début contrat",
        contractenddate: "Date de fin contrat",
        billowner: "Organisme facturé",
        contractowner: "Titulaire du contrat",
        payedby: "Payeur de la facture",
        primaryfinalenergyratio: "Coef EF-EP",
        co2ratio: "Coef CO2 émission",
        energycost: "Coût à l'unité",
        energyunit: "Unité de facturation (m3/t)",
        othermonthlycost: "Autre coût mensuel par compteur",
        otherunitcost: "Autre coût par unité",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      meters: {
        key: "Clé/code",
        name: "Nom",
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        status: "Statut",
        serialnumber: "Matricule",
        address: "Adresse",
        dso: "Distributeur associé",
        acheminement: "Acheminement",
        monthlyconsumption: "Activation relevé mensuel",
        dailyconsumption: "Activation relevé journalier",
        loadcurve: "Activation de la TR",
        contractualdata: "Activation relève données contractuelles",
        associatedcontractid: "Contrat fournisseur associé",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
        authorization: "Autorisation associée",
        usagecode: "Code usage",
        utilityauthorization: "Autorisation fournisseur associée",
        utilitydata: "Activation relève données de facturation",
      },
    },
  },
  authorization: {
    type: "Type d'autorisation",
    energy: "Energie",
    dso: "Distributeur ou fournisseur associé",
    apiaccountmail: "Compte mail API",
    apisecretkey: "Clé primaire",
    legalname: "Nom de l'entité légale",
    datebegin: "Date de début d'autorisation",
    dateend: "Date de fin d'autorisation",
    associatedfile: "Fichier associé",
    verified: "Autorisation validée",
    comment: "Commentaires",
    firstname: "Prénom",
    lastname: "Nom",
    email: "Email",
    postalcode: "Code postal",
    ftpdirectory: "Répertoire FTP",
    dsochoruscode: "Code fournisseur CPP 2017",
    dsofiletemplate: "Template d'import de fichier",
    getAttachedFile: "Joindre les fichiers PDF"
  },
};

// ##############################
// // // Region
// #############################

const region = {
  parameters: {
    parameters: {
      picture: "Photo",
      key: "Clé /Code",
      membernumber: "Numéro adhérent",
      address: "Adresse",
      inseecode: "Code INSEE",
      postalcode: "Code Postal",
      population: "Population",
      territorysurface: "Surface territoire",
      brutsurface: "Totale Surface Utile Brute",
      heatedsurface: "Totale Surface chauffée",
      floorsurface: "Totale Surface Plancher",
      shonsurface: "Totale Surface SHON",
      citycount: "Nombre de communes",
      sitecount: "Nombre de sites",
      buildingcount: "Nombre de bâtiments",
      lightingcount: "Nombre de EP",
      trafficlightcount: "Nombre de feux tricolores",
      othercount: "Nombres Autres",
      email: "Adresse email",
      phone: "Téléphone",
    },
    ratio: {
      energyshon: "kWhEP/SHON",
      costshon: "Ratio TTC/SHON",
      energyhabitant: "Ratio kWhEP/Habitant",
    },
    properties: {
      performancegrade: "Performance - Note",
      performancecomment: "Performance - Commentaire",
      dilapidationgrade: "Vétusté - Note",
      dilapidationcomment: "Vétusté - Commentaire",
      otherproperties: "Autres propriétés",
    },
    other: {
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
  },
  contact: {
    contactlist: {
      name: "Nom ",
      key: "Clé / code",
      status: "Statut",
      role: "Poste / Fonction",
      company: "Structure / Société",
      phone: "Téléphone",
      email: "Email",
      comments: "Commentaires",
      external: "Tag - Interne / Externe / Autres",
      associatedfiles: "Fichiers associés",
      description: "Description",
    },
  },
  energy: {
    electricity: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    gas: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    water: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    heat: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    cold: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    fuel: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    wood: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    propane: {
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
  },
  structure: {
    performancegrade: "Performance globale Note",
    performancecomment: "Performance globale commentaires",
    dilapidationgrade: "Vétusté globale Note",
    dilapidationcomment: "Vétusté globale commentaires",
    otherproperties: "Autres propriétés",
    associatedfiles: "Fichiers associés",
    comments: "Commentaires",
    description: "Description",
  },
  equipments: {
    performancegrade: "Performance Note",
    performancecomment: "Performance commentaires",
    dilapidationgrade: "Vétusté Note",
    dilapidationcomment: "Vétusté commentaires",
    otherproperties: "Autres propriétés",
    associatedfiles: "Fichiers associés",
    comments: "Commentaires",
    description: "Description",
  },
  renewables: {
    pvpotential: "PV",
    solarthermalpotential: "Solaire thermique",
    biomasspotential: "Biomasse",
    geothermalpotential: "Géothermie",
    windpowerpotential: "Eolien",
    associatedfiles: "Fichiers associés",
    comments: "Commentaires",
    description: "Description",
  },
};

// ##############################
// // // Site
// #############################

const site = {
  parameters: {
    parameters: {
      picture: "Photo",
      key: "Clé /Code",
      address: "Adresse",
      buildingcount: "Nombre de bâtiments",
      constructionyear: "Année de construction",
      constructionperiod: "Epoque de construction",
      commissioningyear: "Année de mise en service",
      structuretype: "Type de patrimoine",
      roomcount: "Nombre de zones / salles",
      syncciteos: "Synchroniser avec l'hyperviseur",
      syncsitewithciteos: "Synchroniser le site avec l'hyperviseur",
      email: "Adresse email",
      phone: "Téléphone",
    },
    activity: {
      status: "Statut",
      nafcode: "Code NAF",
      activitytype: "Secteur d'activité",
      activitysubtype: "Sous-secteur d'activité",
      usagecode: "Code usage",
      usage: "Usage/Fonction entité",
      nontertiaryactivity: "Présence de co-activité non tertiaire",
    },
    dimension: {
      shape: "Forme de l'entité",
      length: "Longueur",
      width: "Largeur",
      height: "Hauteur moyenne",
      volume: "Volume",
      surface: "Surface",
      brutsurface: "Surface Utile Brute",
      heatedsurface: "Surface chauffée",
      cooledsurface: "Surface climatisée",
      floorsurface: "Surface Plancher",
      shonsurface: "Surface SHON",
      comments: "Commentaires",
      description: "Description",
    },
    occupation: {
      occupancycountperiode: "Nombre moyen d'occupants - Périodicité",
      occupancycountvalue: "Nombre moyen d'occupants - Valeur",
      maximalcapacity: "Capacité maximale",
      averageoccupancy: "Taux moyen d'occupation (%)",
      occupancytimeperiode: "Temps moyen occupation - Périodicité",
      occupancytimevalue: "Temps moyen occupation - Valeur",
      occupancycomments: "Fréquence d'occupation - Commentaires",
      mondayschedulestart: "Horaire standard d'ouverture le Lundi",
      tuesdayschedulestart: "Horaire standard d'ouverture le Mardi",
      wednesdayschedulestart: "Horaire standard d'ouverture le Mercredi",
      thursdayschedulestart: "Horaire standard d'ouverture le Jeudi",
      fridayschedulestart: "Horaire standard d'ouverture le Vendredi",
      saturdayschedulestart: "Horaire standard d'ouverture le Samedi",
      sundayschedulestart: "Horaire standard d'ouverture le Dimanche",
      mondayscheduleend: "Horaire standard de fermeture le Lundi",
      tuesdayscheduleend: "Horaire standard de fermeture le Mardi",
      wednesdayscheduleend: "Horaire standard de fermeture le Mercredi",
      thursdayscheduleend: "Horaire standard de fermeture le Jeudi",
      fridayscheduleend: "Horaire standard de fermeture le Vendredi",
      saturdayscheduleend: "Horaire standard de fermeture le Samedi",
      sundayscheduleend: "Horaire standard de fermeture le Dimanche",
      comments: "Commentaires",
      description: "Description",
    },
    properties: {
      lastaudit: "Date de dernier audit",
      performancegrade: "Performance - Note",
      performancecomment: "Performance - Commentaire",
      dilapidationgrade: "Vétusté - Note",
      dilapidationcomment: "Vétusté - Commentaire",
      architecturalconstraints: "Contraintes architecturales",
      architecturalconstraintscomment:
        "Contraintes architecturales - Commentaires",
      boilerroomcompliance: "Conformité chaufferie",
      boilerroomcompliancecomment: "Conformité chaufferie - Commentaires",
      otherproperties: "Autres propriétés",
      feedback: "REX occupants",
      lastrehabilitation: "Date de dernière réhabilitation",
      rehabilitationtype: "Type de réhabilitation",
      nextrehabilitation: "Date de prochaine réhabilitation",
      certification: "Certifications",
      internetaccess: "Accès internet",
    },
    other: {
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
      mbminstalled: "Equipements de pilotage sur site",
    },
  },

  contact: {
    contactlist: {
      name: "Nom ",
      key: "Clé / code",
      status: "Statut",
      role: "Poste / Fonction",
      company: "Structure / Société",
      phone: "Téléphone",
      email: "Email",
      comments: "Commentaires",
      external: "Tag - Interne / Externe / Autres",
      associatedfiles: "Fichiers associés",
      description: "Description",
    },
  },

  energy: {
    electricity: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    gas: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    water: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    heat: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    cold: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    fuel: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    wood: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    propane: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
  },
  structure: {
    uponderation: "Pondération (U structure)",
    ustructure: "Ustructure",
    airdeperdition: "Part Déperditions Renouvellement de l'air",
    thermicaldeperdition: "Part Déperditions ponts thermiques",
    jointwall: "Mitoyenneté",
    associatedfiles: "Fichiers associés",
    comments: "Commentaires",
    description: "Description",
  },
  equipments: {
    synthesis: {
      other: "Autres propriétés libres",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    equipmentlist: {
      name: "Nom",
      key: "Clé/code",
      category: "Catégorie Système / usage",
      system: "Système",
      type: "Type d'équipement",
      status: "Statut",
      localization: "Localisation",
      energysource: "Source d'énergie",
      installationdate: "Année d'installation",
      divisionunit: "Clé de répartition",
      consumptionpart: "Part de la consommation",
      billingpart: "Part de la facturation",
      productionpart: "Part de la production",
      averageusageperiod: "Temps moyen utilisation - Périodicité",
      averageusagetime: "Temps moyen utilisation - Valeur",
      usagefrequency: "Fréquence d'utilisation - Commentaires",
      defaultsetpoint: "Consigne par défaut",
      weighting: "Pondération",
      efficiency: "Rendement",
      device: "Appareil",
      devicekey: "Clé",
      devicename: "Nom",
      devicecategory: "Catégorie",
      devicetechnology: "Techno",
      devicemodel: "Modèle",
      devicecaracteristicval:
        "Rendement d'impacts / Valeur caractéristique de performance",
      devicecaracteristicunit: "Unité",
      devicerenewalrateflow: "Taux de brassage (vol/h)",
      deviceelectricalpower: "Puissance élec.",
      devicethermicalpower: "Puissance thermique",
      deviceelectricalunitpower: "Puissance élec unitaire?",
      devicecoldpower: "Puissance frigorifique",
      devicecop: "COP",
      deviceefficiency: "Rendement",
      devicerateflow: "Débit",
      devicedimension: "Dimension",
      devicevalve: "Type de vanne",
      devicecarbonfootprint: "Empreinte carbone",
      devicegreyenergy: "Energie grise",
      performancegrade: "Commentaires propriétés",
      performancecomment: "Performance Note",
      dilapidationgrade: "Performance commentaires",
      dilapidationcomment: "Vétusté Note",
      otherproperties: "Autres propriétés",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    tertiarybill: {
      heating: "Chauffage",
      cooling: "Refroidissement",
      heatingproductiondevice: "Générateur principal chauffage",
      heatingdistributiondevice: "Type principal d'émetteur de chauffage",
      coolingproductiondevice: "Générateur principal de rafraîchissement",
      coolingdistributiondevice: "Type principal de ventilation",
      hotwaterdevice: "Type de production d'eau chaude sanitaire",
      officenaturallighting: "Niveau d'éclairage naturel des locaux",
      corridornaturallighting: "Niveau d'éclairage naturel des circulations",
      lightingdevice: "Type d'éclairage artificiel",
      elavatorcount: "Nombre d'ascenseurs",
      levelcount: "Nombre de niveau desservis",
      capacity: "Capacité individuelle",
      escalatorfulltime:
        "Nombre d'escalier mécanique en fonctionnement continu",
      escalatordetection: "Nombre d'escalier mécanique asservi à la détection",
      mecsidewalkfulltime:
        "Nombre de trottoir mécanique en fonctionnement continu",
      mecsidewalkdetection:
        "Nombre de trottoir mécanique asservi à la détection",
    },
  },
  renewables: {
    synthesis: {
      pv: "PV",
      pvrooforientation: "Orientation toiture",
      pvrooftilt: "Inclinaison",
      pvroofsurface: "Toiture - surface disponible",
      pvsolarmask: "Présence de masque solaire",
      pvheatingcompatibility: "Compatibilité avec le système de chauffage",
      pvfaisability: "Niveau de faisabilité",
      solarthermal: "Solaire thermique",
      solarthermalrooforientation: "Orientation toiture",
      solarthermalrooftilt: "Inclinaison",
      solarthermalroofsurface: "Toiture - surface disponible",
      solarthermalsolarmask: "Présence de masque solaire",
      solarthermalheatingcompatibility:
        "Compatibilité avec le système de chauffage",
      solarthermalsuitability: "Adéquation avec les besoins",
      solarthermalfaisability: "Niveau de faisabilité",
      biomass: "Biomasse",
      biomassgroundavailablesurface: "Surface terrain disponible",
      biomassdeliverycapacity: "Capacité de livraison",
      biomasssilocapacity: "Foncier suffisant pour silo",
      biomassheatingcompatibility: "Compatibilité avec le système de chauffage",
      biomassfaisability: "Niveau de faisabilité",
      geothermal: "Géothermie",
      geothermalgroundavailablesurface: "Surface terrain disponible",
      geothermalgroundtype: "Nature du sol",
      geothermalcompatibility: "Compatibilité avec le système de chauffage",
      geothermalfaisability: "Niveau de faisabilité",
      other: "Autres propriétés libres (ex : éolien, hydro ...)",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    equipmentlist: { name: "Nom", key: "Clé/code", type: "Type ENR" },
  },
  tertiarybill: {
    intertiarybill: "Entité assujettie au décret tertiaire",
    startdate:
      "Mois de début de la plage de 12 mois consécutif (année de référence)",
    djuref:
      "DJU de l'année de référence",
    electricityrefconsumption:
      "Electricité (kWh): consommation année de référence",
    gasrefconsumption:
      "Gaz naturel réseaux (kWh) : consommation année de référence",
    liquidgasrefconsumption:
      "Gaz naturel liquéfié (kg) : consommation année de référence",
    propanem3refconsumption:
      "Gaz propane (m3): consommation année de référence",
    propanekgrefconsumption:
      "Gaz propane (kg): consommation année de référence",
    butanem3refconsumption: "Gaz butane (m3): consommation année de référence",
    butanekgrefconsumption: "Gaz butane (kg): consommation année de référence",
    fuelrefconsumption:
      "Fioul domestique (l) : consommation année de référence",
    coalrefconsumption:
      "Charbon agglomérés et briquettes (kg) : consommation année de référence",
    houillerefconsumption: "Houille (kg) : consommation année de référence",
    industrywoodrefconsumption:
      "Bois Plaquettes d'industrie (kg) : consommation année de référence",
    forestwoodrefconsumption:
      "Bois Plaquettes forestières (kg) : consommation année de référence",
    granulewoodrefconsumption:
      "Bois Granulés (pellets) ou briquettes (kg) : consommation année de référence",
    logwoodrefconsumption:
      "Bois Bûches (Stère) : consommation année de référence",
    heatnetworkrefconsumption:
      "Réseau de chaleur (kWh) : consommation année de référence",
    coldnetworkrefconsumption:
      "Réseau de froid (kWh électrique) : consommation année de référence",
  },
};

// ##############################
// // // Equipement Urbain
// #############################
const urbanequipment = {
  parameters: {
    parameters: {
      picture: "Photo",
      key: "Clé /Code",
      address: "Adresse",
      constructionyear: "Année de construction",
      commissioningyear: "Année de mise en service",
      structuretype: "Type de patrimoine",
      email: "Adresse email",
      phone: "Téléphone",
    },
    activity: {
      status: "Statut",
      activitytype: "Secteur d'activité",
      activitysubtype: "Sous-secteur d'activité",
      usagecode: "Code usage",
      usage: "Usage/Fonction entité",
    },
    dimension: {
      length: "Longueur",
      width: "Largeur",
      height: "Hauteur moyenne",
      volume: "Volume",
      surface: "Surface",
      comments: "Commentaires",
      description: "Description",
    },
    occupation: {
      occupancytimeperiode: "Temps moyen activité - Périodicité",
      occupancytimevalue: "Temps moyen activité - Valeur",
      occupancycomments: "Fréquence d'activité - Commentaires",
      mondayschedulestart: "Horaire standard d'ouverture le Lundi",
      tuesdayschedulestart: "Horaire standard d'ouverture le Mardi",
      wednesdayschedulestart: "Horaire standard d'ouverture le Mercredi",
      thursdayschedulestart: "Horaire standard d'ouverture le Jeudi",
      fridayschedulestart: "Horaire standard d'ouverture le Vendredi",
      saturdayschedulestart: "Horaire standard d'ouverture le Samedi",
      sundayschedulestart: "Horaire standard d'ouverture le Dimanche",
      mondayscheduleend: "Horaire standard de fermeture le Lundi",
      tuesdayscheduleend: "Horaire standard de fermeture le Mardi",
      wednesdayscheduleend: "Horaire standard de fermeture le Mercredi",
      thursdayscheduleend: "Horaire standard de fermeture le Jeudi",
      fridayscheduleend: "Horaire standard de fermeture le Vendredi",
      saturdayscheduleend: "Horaire standard de fermeture le Samedi",
      sundayscheduleend: "Horaire standard de fermeture le Dimanche",
      comments: "Commentaires",
      description: "Description",
    },
    properties: {
      lastaudit: "Date de dernier audit",
      performancegrade: "Performance - Note",
      performancecomment: "Performance - Commentaire",
      dilapidationgrade: "Vétusté - Note",
      dilapidationcomment: "Vétusté - Commentaire",
      architecturalconstraints: "Contraintes architecturales",
      architecturalconstraintscomment:
        "Contraintes architecturales - Commentaires",
      otherproperties: "Autres propriétés",
      feedback: "REX",
      lastrehabilitation: "Date de dernière réhabilitation",
      rehabilitationtype: "Type de réhabilitation",
      nextrehabilitation: "Date de prochaine réhabilitation",
      certification: "Certifications",
      internetaccess: "Accès internet",
    },
    other: {
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
      mbminstalled: "Equipements de pilotage sur site",
    },
  },
  energy: {
    electricity: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    water: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
  },
  equipments: {
    equipmentlist: {
      name: "Nom",
      key: "Clé/code",
      category: "Catégorie Système / usage",
      system: "Système",
      type: "Type d'équipement",
      status: "Statut",
      localization: "Localisation",
      energysource: "Source d'énergie",
      installationdate: "Année d'installation",
      divisionunit: "Clé de répartition",
      consumptionpart: "Part de la consommation",
      billingpart: "Part de la facturation",
      productionpart: "Part de la production",
      averageusageperiod: "Temps moyen utilisation - Périodicité",
      averageusagetime: "Temps moyen utilisation - Valeur",
      usagefrequency: "Fréquence d'utilisation - Commentaires",
      defaultsetpoint: "Consigne par défaut",
      weighting: "Pondération",
      efficiency: "Rendement",
      device: "Appareil",
      devicekey: "Clé",
      devicename: "Nom",
      devicecategory: "Catégorie",
      devicetechnology: "Techno",
      devicemodel: "Modèle",
      devicecaracteristicval:
        "Rendement d'impacts / Valeur caractéristique de performance",
      devicecaracteristicunit: "Unité",
      devicerenewalrateflow: "Taux de brassage (vol/h)",
      deviceelectricalpower: "Puissance élec.",
      devicethermicalpower: "Puissance thermique",
      deviceelectricalunitpower: "Puissance élec unitaire?",
      devicecoldpower: "Puissance frigorifique",
      devicecop: "COP",
      deviceefficiency: "Rendement",
      devicerateflow: "Débit",
      devicedimension: "Dimension",
      devicevalve: "Type de vanne",
      devicecarbonfootprint: "Empreinte carbone",
      devicegreyenergy: "Energie grise",
      performancegrade: "Commentaires propriétés",
      performancecomment: "Performance Note",
      dilapidationgrade: "Performance commentaires",
      dilapidationcomment: "Vétusté Note",
      otherproperties: "Autres propriétés",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
  },
};

// ##############################
// // // Zone
// #############################
const zone = {
  parameters: {
    parameters: {
      picture: "Photo",
      key: "Clé /Code",
      address: "Adresse",
      floornumber: "Niveau/Etage",
      constructionyear: "Année de construction",
      constructionperiod: "Epoque de construction",
      commissioningyear: "Année de mise en service",
      siret: "Numéro SIRET",
      siren: "Numéro SIREN",
      nic: "Numéro NIC",
      email: "Adresse email",
      phone: "Téléphone",
    },
    activity: {
      status: "Statut",
      activitytype: "Secteur d'activité",
      activitysubtype: "Sous-secteur d'activité",
      usagecode: "Code usage",
      usage: "Usage/Fonction entité",
    },
    dimension: {
      length: "Longueur",
      width: "Largeur",
      height: "Hauteur moyenne",
      volume: "Volume",
      surface: "Surface",
      brutsurface: "Surface Utile Brute",
      heatedsurface: "Surface chauffée",
      cooledsurface: "Surface climatisée",
      floorsurface: "Surface Plancher",
      shonsurface: "Surface SHON",
      comments: "Commentaires",
      description: "Description",
    },
    occupation: {
      occupancycountperiode: "Nombre moyen d'occupants - Périodicité",
      occupancycountvalue: "Nombre moyen d'occupants - Valeur",
      maximalcapacity: "Capacité maximale",
      averageoccupancy: "Taux moyen d'occupation (%)",
      occupancytimeperiode: "Temps moyen occupation - Périodicité",
      occupancytimevalue: "Temps moyen occupation - Valeur",
      occupancycomments: "Fréquence d'occupation - Commentaires",
      mondayschedulestart: "Horaire standard d'ouverture le Lundi",
      tuesdayschedulestart: "Horaire standard d'ouverture le Mardi",
      wednesdayschedulestart: "Horaire standard d'ouverture le Mercredi",
      thursdayschedulestart: "Horaire standard d'ouverture le Jeudi",
      fridayschedulestart: "Horaire standard d'ouverture le Vendredi",
      saturdayschedulestart: "Horaire standard d'ouverture le Samedi",
      sundayschedulestart: "Horaire standard d'ouverture le Dimanche",
      mondayscheduleend: "Horaire standard de fermeture le Lundi",
      tuesdayscheduleend: "Horaire standard de fermeture le Mardi",
      wednesdayscheduleend: "Horaire standard de fermeture le Mercredi",
      thursdayscheduleend: "Horaire standard de fermeture le Jeudi",
      fridayscheduleend: "Horaire standard de fermeture le Vendredi",
      saturdayscheduleend: "Horaire standard de fermeture le Samedi",
      sundayscheduleend: "Horaire standard de fermeture le Dimanche",
      comments: "Commentaires",
      description: "Description",
    },
    properties: {
      lastaudit: "Date de dernier audit",
      performancegrade: "Performance - Note",
      performancecomment: "Performance - Commentaire",
      dilapidationgrade: "Vétusté - Note",
      dilapidationcomment: "Vétusté - Commentaire",
      architecturalconstraints: "Contraintes architecturales",
      architecturalconstraintscomment:
        "Contraintes architecturales - Commentaires",
      boilerroomcompliance: "Conformité chaufferie",
      boilerroomcompliancecomment: "Conformité chaufferie - Commentaires",
      otherproperties: "Autres propriétés",
      feedback: "REX occupants",
      lastrehabilitation: "Date de dernière réhabilitation",
      rehabilitationtype: "Type de réhabilitation",
      nextrehabilitation: "Date de prochaine réhabilitation",
      certification: "Certifications",
      internetaccess: "Accès internet",
      intertiarybill: "Entité assujettie au décret tertiairee",
    },
    other: {
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
      mbminstalled: "Equipements de pilotage sur site",
    },
  },
  contact: {
    contactlist: {
      name: "Nom ",
      key: "Clé / code",
      status: "Statut",
      role: "Poste / Fonction",
      company: "Structure / Société",
      phone: "Téléphone",
      email: "Email",
      comments: "Commentaires",
      external: "Tag - Interne / Externe / Autres",
      associatedfiles: "Fichiers associés",
      description: "Description",
    },
  },
  energy: {
    electricity: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    gas: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    water: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    heat: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    cold: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    fuel: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    wood: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
    propane: {
      meters: {
        meternumber: "Numéro de compteur (RAE, PDL, PRM, PCE, etc)",
        divisionunit: "Clé de répartition / Pondération - Unité",
        divisionvalue: "Clé de répartition / valeur",
      },
      reference: {
        referenceyear: "Année de référence",
        referencefinalenergy: "Conso annuelle EF référence",
        referenceprimaryenergy: "Conso annuelle EP référence",
        referenceco2: "Emission annuelle CO2 référence",
        referencesubscriptioncost: "Montant abonnement annuel TTC référence",
        referencetotalcost: "Montant annuel € TTC référence",
      },
    },
  },
  structure: {
    synthesis: {
      uponderation: "Pondération (U structure)",
      ustructure: "Ustructure",
      airdeperdition: "Part Déperditions Renouvellement de l'air",
      thermicaldeperdition: "Part Déperditions ponts thermiques",
      jointwall: "Mitoyenneté",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    walls: {
      walls: {
        name: "Nom",
        key: "Clé/code",
        type: "Type de cloison",
        materials: "Matériaux",
        length: "Longueur",
        width: "Largeur",
        surface: "Surface",
        thickness: "Epaisseur",
        thicknessprecision: "Epaisseur - niveau de précision",
        walldependency: "Dépendance paroi",
        deperdition: "Déperdition vers",
        uponderation: "Pondération U paroi",
        thermicalresistance: "Résistance thermique paroi",
        uwall: "U paroi",
        deperditionpart: "Part des déperditions totales",
        wallorientation: "Orientation paroi",
        rooftilt: "Toiture - Inclinaison",
        performancegrade: "Performance Note",
        performancecomment: "Performance commentaires",
        dilapidationgrade: "Vétusté Note",
        dilapidationcomment: "Vétusté commentaires",
        otherproperties: "Autres propriétés",
        associatedfiles: "Fichiers associés",
        comments: "Commentaires",
        description: "Description",
      },
      materials: {
        key: "Clé/code",
        name: "Matériau",
        refmaterial: "Matériau de référence",
        uncertainty: "Incertitude type matériau",
        umaterial: "U matériau",
        thickness: "Epaisseur",
        thicknessprecision: "Epaisseur - niveau de précision",
        comments: "Commentaires",
        category: "Catégorie",
        walltype: "Type de matériau",
        functionality: "Fonction",
        usualwall: "Type de paroi habituellement associé",
        thermicalconductivity: "Conductivité Thermique",
        thermicalresistance: "Résistance thermique",
        thermicalcapacity: "Capacité thermique",
        volumicmass: "Masse Volumique",
        carbonfootprint: "Empreinte carbone",
        greyenergy: "Energie grise",
        vapordiffusion: "Facteur de diffusion de la vapeur d'eau",
      },
    },
    tertiarybill: {
      walltype: "Typologie façade",
      wallisolation: "Isolation thermique des façades",
      pinionisolation: "Isolation thermique des pignons",
      mainthermicalisolation: "Mode d'isolation thermique principal",
      woodsthermicaltreatment: "Traitement thermique des menuiseries",
      rooftype: "Typologie toiture",
      roofthermicaltreatment: "Traitement thermique de la toiture",
      floortype: "Typologie plancher bas",
      floortisolation: "Isolation thermique du plancher bas",
    },
  },
  equipments: {
    equipmentlist: {
      name: "Nom",
      key: "Clé/code",
      category: "Catégorie Système / usage",
      system: "Système",
      type: "Type d'équipement",
      status: "Statut",
      localization: "Localisation",
      energysource: "Source d'énergie",
      installationdate: "Année d'installation",
      divisionunit: "Clé de répartition",
      consumptionpart: "Part de la consommation",
      billingpart: "Part de la facturation",
      productionpart: "Part de la production",
      averageusageperiod: "Temps moyen utilisation - Périodicité",
      averageusagetime: "Temps moyen utilisation - Valeur",
      usagefrequency: "Fréquence d'utilisation - Commentaires",
      defaultsetpoint: "Consigne par défaut",
      weighting: "Pondération",
      efficiency: "Rendement",
      device: "Appareil",
      devicekey: "Clé",
      devicename: "Nom",
      devicecategory: "Catégorie",
      devicetechnology: "Techno",
      devicemodel: "Modèle",
      devicecaracteristicval:
        "Rendement d'impacts / Valeur caractéristique de performance",
      devicecaracteristicunit: "Unité",
      devicerenewalrateflow: "Taux de brassage (vol/h)",
      deviceelectricalpower: "Puissance élec.",
      devicethermicalpower: "Puissance thermique",
      deviceelectricalunitpower: "Puissance élec unitaire?",
      devicecoldpower: "Puissance frigorifique",
      devicecop: "COP",
      deviceefficiency: "Rendement",
      devicerateflow: "Débit",
      devicedimension: "Dimension",
      devicevalve: "Type de vanne",
      devicecarbonfootprint: "Empreinte carbone",
      devicegreyenergy: "Energie grise",
      performancegrade: "Commentaires propriétés",
      performancecomment: "Performance Note",
      dilapidationgrade: "Performance commentaires",
      dilapidationcomment: "Vétusté Note",
      otherproperties: "Autres propriétés",
      associatedfiles: "Fichiers associés",
      comments: "Commentaires",
      description: "Description",
    },
    tertiarybill: {
      heating: "Chauffage",
      cooling: "Refroidissement",
      heatingproductiondevice: "Générateur principal chauffage",
      heatingdistributiondevice: "Type principal d'émetteur de chauffage",
      coolingproductiondevice: "Générateur principal de rafraîchissement",
      coolingdistributiondevice: "Type principal de ventilation",
      hotwaterdevice: "Type de production d'eau chaude sanitaire",
      officenaturallighting: "Niveau d'éclairage naturel des locaux",
      corridornaturallighting: "Niveau d'éclairage naturel des circulations",
      lightingdevice: "Type d'éclairage artificiel",
      elavatorcount: "Nombre d'ascenseurs",
      levelcount: "Nombre de niveau desservis",
      capacity: "Capacité individuelle",
      escalatorfulltime:
        "Nombre d'escalier mécanique en fonctionnement continu",
      escalatordetection: "Nombre d'escalier mécanique asservi à la détection",
      mecsidewalkfulltime:
        "Nombre de trottoir mécanique en fonctionnement continu",
      mecsidewalkdetection:
        "Nombre de trottoir mécanique asservi à la détection",
    },
  },
  renewables: {
    synthesis: {
      pv: "PV",
      solarthermal: "Solaire thermique",
      biomass: "Biomasse",
      geothermal: "Géothermie",
      other: "Autres propriétés libres (ex : éolien",
    },
    equipmentlist: { name: "Nom", key: "Clé/code", type: "Type ENR" },
  },
  tertiarybill: {
    intertiarybill: "Entité assujettie au décret tertiaire",
    startdate: "Mois de début de la plage de 12 mois consécutif",
    djuref:
      "DJU de l'année de référence",
    electricityrefconsumption:
      "Electricité (kWh): consommation année de référence",
    gasrefconsumption:
      "Gaz naturel réseaux (kWh) : consommation année de référence",
    liquidgasrefconsumption:
      "Gaz naturel liquéfié (kg) : consommation année de référence",
    propanem3refconsumption:
      "Gaz propane (m3): consommation année de référence",
    propanekgrefconsumption:
      "Gaz propane (kg): consommation année de référence",
    butanem3refconsumption: "Gaz butane (m3): consommation année de référence",
    butanekgrefconsumption: "Gaz butane (kg): consommation année de référence",
    fuelrefconsumption:
      "Fioul domestique (l) : consommation année de référence",
    coalrefconsumption:
      "Charbon agglomérés et briquettes (kg) : consommation année de référence",
    houillerefconsumption: "Houille (kg) : consommation année de référence",
    industrywoodrefconsumption:
      "Bois Plaquettes d'industrie (kg) : consommation année de référence",
    forestwoodrefconsumption:
      "Bois Plaquettes forestières (kg) : consommation année de référence",
    granulewoodrefconsumption:
      "Bois Granulés (pellets) ou briquettes (kg) : consommation année de référence",
    logwoodrefconsumption:
      "Bois Bûches (Stère) : consommation année de référence",
    heatnetworkrefconsumption:
      "Réseau de chaleur (kWh) : consommation année de référence",
    coldnetworkrefconsumption:
      "Réseau de froid (kWh électrique) : consommation année de référence",
  },
};

export { batiment, compte, region, site, zone, urbanequipment, meter, usage, thresholdtext, mbmtab };
